const size = {
	xs: '575.98px',
	sm: '576px',
	md: '767px',
	lg: '992px',
	xl: '1200px'
}

export default {
	xs: `(max-width: ${size.xs})`,
	sm: `(min-width: ${size.sm})`,
	md: `(min-width: ${size.md})`,
	lg: `(min-width: ${size.lg})`,
	xl: `(min-width: ${size.xl})`
}